import { render, staticRenderFns } from "./ActionsPage.vue?vue&type=template&id=9873b6ba"
import script from "./ActionsPage.vue?vue&type=script&lang=js"
export * from "./ActionsPage.vue?vue&type=script&lang=js"
import style0 from "./ActionsPage.vue?vue&type=style&index=0&id=9873b6ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports